import { createStyles } from '@material-ui/core';
import { borderRadius, getSpacing } from 'stylesheet';
var MuiDialogOverride = createStyles({
  paper: {
    padding: "".concat(getSpacing(3), " ").concat(getSpacing(5)),
    borderRadius: borderRadius.large,
    alignItems: 'center'
  }
});
export default MuiDialogOverride;